import React from 'react'
import { DataTool, type DataToolProps } from '@ztechapps/webui.data-tools'
import { useCompanyListContext } from './Context'
import { companyListFieldConfig } from './constants'

export const CompanyListDataTool = ({ searchPlaceHolder, ...props }: DataToolProps) => {
  const { listResult } = useCompanyListContext()

  return (
    <DataTool
      fieldsConfig={companyListFieldConfig}
      onRefresh={listResult.refetch}
      searchPlaceHolder={searchPlaceHolder ?? 'Search companies'}
      {...listResult}
      {...props}
      onSort={null}
    />
  )
}
